var map = {
	"./countries-2024": 73159,
	"./countries-2024.json": 73159,
	"./countries-2025": 2232,
	"./countries-2025.json": 2232,
	"./countries-info": 3149,
	"./countries-info.json": 3149,
	"./countries-tac": 47608,
	"./countries-tac.json": 47608,
	"./countries-versions": 74202,
	"./countries-versions.json": 74202,
	"./i18n": 10052,
	"./i18n.json": 10052,
	"./languages": 81950,
	"./languages.json": 81950
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 12062;